<template>
  <div class="foot-login">
    <b-row>
      <b-col cols="12" md="8" class="primero">
        <div style="margin: 7% 10% 10% 10%">
          <b-form @submit="onSubmit" @reset="onReset">
            <div>
              <h3 class="color-primary">Servicio al cliente</h3>
              <p class="mb-4 text-justify">
                La sección de servicio al cliente es un espacio creado para que
                pueda gestionar de forma ágil las solicitudes generales y/o
                cualquier tipo de inconveniente o inconsistencia en el Portal.
                Para brindarle un mejor servicio, por favor diligencie todos los
                campos de este formulario.
              </p>
            </div>
            <b-row>
              <b-col cols="12" class="label">
                <b-form-group>
                  <b-form-input type="text" id="asunto" placeholder="* Asunto" v-model="asunto" required></b-form-input>
                </b-form-group>
                <span v-if="errors ? errors.asunto : ''" :class="['text-danger']">{{ errors.asunto[0] }}</span>
              </b-col>
              <b-col cols="12" md="6">
                <!-- Este select lo estpi poniendo con data.json -->
                <SelectComponet :data="selectTipoIncidencia" @selectedValue="tincidencia = $event"
                  class="select-footer1"></SelectComponet>
                <span v-if="errors ? errors.tincidencia : ''" :class="['text-danger']">{{ errors.tincidencia[0]
                }}</span>
              </b-col>

              <b-col cols="12" md="6">
                <SelectComponet :data="SelectPriodidad" @selectedValue="tprioridad = $event" class="select-footer2">
                </SelectComponet>
                <span v-if="errors ? errors.tprioridad : ''" :class="['text-danger']">{{ errors.tprioridad[0] }}</span>
              </b-col>

              <b-col cols="12">
                <b-form-group class="mb-4">
                  <b-form-textarea id="descripcion" v-model="descripcion" placeholder="* Descripción" rows="4"
                    max-rows="4" required></b-form-textarea>
                </b-form-group>
                <span v-if="errors ? errors.descripcion : ''" :class="['text-danger']">{{ errors.descripcion[0]
                }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <p>
                  <b>Anexos:</b>
                  total máximo de 4 archivos, peso máximo de todos los archivos
                  10 MB.
                </p>
              </b-col>
              <b-col cols="12" md="6">
                <FileInput multiple @filesSel="anexos = $event"></FileInput>
                <span v-if="errors ? errors.anexos : ''" :class="['text-danger']">{{ errors.anexos[0] }}</span>
              </b-col>
            </b-row>
            <div class="text-right">
              <b-button class="button-carga" style="margin: 7px 7px 7px 7px" type="reset">Borrar</b-button>
              <b-button class="button-carga" style="margin: 7px 0px 7px 7px" type="submit">Enviar</b-button>
            </div>
          </b-form>
        </div>
      </b-col>

      <!-- Panel Derecho -->
      <b-col cols="12" md="4">
        <b-row class="segundo">
          <b-col style="margin: 7% 5% -5% 5%">
            <h6 class="color-secundary">¿Necesitas asistencia?</h6>
            <p style="margin-top: 18px">
              Comunícate con el equipo de Servicio al Cliente
            </p>
            <!-- <SelectComponet :data="SelectServicioCliente" @selectedValue="servicioCliente = $event"></SelectComponet> -->
            <div class="cuadro-especialistas-1">
              <p class="pl-4 pt-2">
                <b>Servicio al cliente</b>
                <br /><b>WhatsApp: </b>301 340 84 15 opción intermediario <br /><b>Teléfono: </b>(604) 448 09 00 opción
                2 >
                opción 3 <br /><b>Correo electrónico: </b>
                <a href="mailto:servicioalcliente@fga.com.co" class="mail_ref">servicioalcliente@fga.com.co</a>
              </p>
            </div>
            <br />
            <!-- <div class="cuadro-especialistas-2">
              <p class="pl-4 pt-4">
                <b>Ayde Patricia Hernández Lugo</b>
                <br />Especialista de Negocios <br />Teléfono: 3174291300
                <br /><a href="mailto:ahernandez@fga.com.co" class="mail_ref">ahernandez@fga.com.co</a>
                <br />
                <br />
                <b>María Camila Morales Hernández</b>
                <br />Especialista de Negocios <br />Teléfono: 3102711097
                <br /><a href="mailto:mmorales@fga.com.co" class="mail_ref">mmorales@fga.com.co</a>
                <br />
                <br />
                <b>Omar Yesid Moncada Buitrago</b>
                <br />Especialista de Negocios <br />Teléfono: 3102772009
                <br /><a href="mailto:omoncada@fga.com.co" class="mail_ref">omoncada@fga.com.co</a>
                <br />
                <br />
                <b>Paola Andrea Restrepo Carmona</b>
                <br />Especialista de Negocios <br />Teléfono: 3102772011
                <br /><a href="mailto:prestrepo@fga.com.co" class="mail_ref">prestrepo@fga.com.co</a>
                <br />
                <br />
                <b>Sara Valentina Delgado Hernández</b>
                <br />Especialista de Negocios <br />Teléfono: 3102772009
                <br /><a href="mailto:sdelgado@fga.com.co" class="mail_ref">sdelgado@fga.com.co</a>
                <br />
                <br />
                <b>Yulie Cuadros Jaramillo</b>
                <br />Especialista de Negocios <br />Teléfono: 3182802125
                <br /><a href="mailto:ycuadros@fga.com.co" class="mail_ref">ycuadros@fga.com.co</a>
                <br />
                <br />
              </p>
            </div> -->
            <!-- <SelectComponet
              :data="SelectOperaciones"
              @selectedValue="operaciones = $event"
              :select_size="3"
            ></SelectComponet>
            <SelectComponet
              :data="SelectEspecialista"
              @selectedValue="especialista = $event"
              :select_size="9"
            ></SelectComponet>-->
          </b-col>
        </b-row>
        <b-row class="tercero">
          <b-col>
            <h6>Sede Medellín</h6>
            <p>
              Carrera 43A N° 19-17
              <br />Block Centro Empresarial - Piso 9 <br />PBX: (604) 448 09 00
            </p>
            <h6>Sede Bogotá</h6>
            <p>
              Carrera 7 Nº 71-21
              <br />Edificio Avenida Chile – Torre B – Of. 403 <br />
              PBX: (601)747 75 68
            </p>
            <h6>Aviso de Privacidad</h6>
            <p>
              En cumplimiento de la Ley 1581 de 2012, FGA Fondo de Garantías S.A. informa que tus datos personales serán
              tratados para la gestión de la relación comercial y/o contractual vigente. Podrás ejercer tus derechos de
              conocimiento, actualización, rectificación o supresión escribiendo a info@fga.com.co. Consulta nuestra
              política de tratamiento de datos en: www.fga.com.co
            </p>

            <!-- <h6>Línea de atención gratuita</h6>
            <p>01 8000 423 882</p> -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Ultima linea -->
    <b-row class="foot">
      <b-col cols="12" md="8" class="mb-1">
        <div class="mb-3 foot-todos-derechos">
          &nbsp;
          <br />FGA - Todos los derechos reservados
        </div>
      </b-col>
      <b-col cols="12" md="4" class="mb-1">
        <div class="mb-3 foot-todos-derechos">
          &nbsp;
          <br />Visite nuestras redes
          <!-- <i class="icon-social-linkedin icons font-2xl mt-1 ml-3"></i> -->

          <a href="https://www.linkedin.com/company/fga-fondo-de-garantias" class="m-3" target="_blank"
            data-toggle="tooltip" title="LinkedIn">
            <i class="fa fa-linkedin fa-2x"></i>
          </a>
          <a href="https://www.instagram.com/fgafondodegarantias/" target="_blank" data-toggle="tooltip"
            title="Instragram">
            <i class="fa fa-instagram fa-2x"></i>
          </a>
          <a href="https://www.facebook.com/FGAFondodeGarantias" class="m-3" target="_blank" data-toggle="tooltip"
            title="Facebook">
            <i class="fa fa-facebook fa-2x"></i>
          </a>
          <a href="https://www.youtube.com/user/FGAFondoGarantias" target="_blank" data-toggle="tooltip"
            title="YouTube">
            <i class="fa fa-youtube-play fa-2x"></i>
          </a>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SelectTipoIncidencia from "@/data/SelectTipoIncidencia.json";
import SelectPriodidad from "@/data/SelectPriodidad.json";
import SelectServicioCliente from "@/data/SelectServicioCliente.json";
import SelectOperaciones from "@/data/SelectOperaciones.json";
import SelectEspecialista from "@/data/SelectEspecialista.json";

//iconos

export default {
  name: "Foote",
  components: {
    SelectComponet: () => import("@/components/form/Select.vue"),
    FileInput: () => import("@/components/form/FileInput.vue"),
  },
  computed: {},
  data() {
    return {
      selectTipoIncidencia: SelectTipoIncidencia,
      SelectPriodidad: SelectPriodidad,
      SelectServicioCliente: SelectServicioCliente,
      SelectOperaciones: SelectOperaciones,
      SelectEspecialista: SelectEspecialista,
      asunto: "",
      tincidencia: null,
      Modeltincidencia: null,
      tprioridad: null,
      descripcion: "",
      anexos: [],
      servicioCliente: null,
      operaciones: null,
      especialista: null,
      errors: {},
    };
  },
  // anexos:["El campo anexos es obligatorio."]
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      var datos = [];
      datos.push({
        Asunto: this.asunto,
        periocidad: this.tprioridad,
        TipoIncidencia: this.tincidencia,
        Descripcion: this.descripcion,
        Files: this.anexos,
      });
    },
    onReset(evt) {
      this.asunto = null;
      this.tprioridad = null;
      this.tincidencia = null;
      this.descripcion = null;
      this.anexos = [];
    },
  },
};
</script>
<style>
.mail_ref {
  color: #000;
  text-decoration: none;
}

.mail_ref:hover {
  color: #000;
  text-decoration: underline;
}
</style>
